import React, { useState } from 'react';
import Button from '../../../../common/components/Button/Button';
import { Modal } from 'react-bootstrap';
import './MessageBodyModal.scss';

const MessageBodyModal = ({ url }) => {
  const [showContentModal, setShowContentModal] = useState(false);

  const openModal = () => {
    setShowContentModal(true);
  };
  const closeModal = () => {
    setShowContentModal(false);
  };

  return (
    <div>
      <Button size={'xs'} label={'view'} bsStyle={'primary'} handleClick={openModal} />
      <Modal show={showContentModal} onHide={closeModal} bsSize={'lg'}>
        <Modal.Header closeButton>
          <Modal.Title>Email Content</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className={'message-modal--body-iframe'}>
            <iframe width={'100%'} height={'100%'} src={url} />
          </div>
        </Modal.Body>
        <Modal.Footer />
      </Modal>
    </div>
  );
};

export default MessageBodyModal;
